import { refreshToken } from 'client/api/cognito'
import { StateInterface } from 'client/Interfaces/StateInterface'
import { ActionCreator } from 'typescript-fsa'

import { Translation } from '../Other/Translation'
import { actionCreator, actionCreatorAsync, AsyncAction } from './index'

const _translationsLoaded: ActionCreator<string> = actionCreator<string>('TRANSLATIONS_LOADED')

export function getTranslations(lang?: string) {
  return async (dispatch, getState) => {
    const state: StateInterface = getState()

    let locale = lang || state.company.locale || state.token.locale

    // Refresh the token if the language saved in the company is different than in the token.
    // This is expected after the language change on the ACC side
    if (!state.token?.locale?.includes(state.company.language) && !lang) {
      await refreshToken()
      locale = `${state.company.language}_${state.company.country}`
    }

    Translation.locale = locale
    if (getState().language !== locale) {
      await Translation.load(locale)
    }
    dispatch(_translationsLoaded(locale))
  }
}

export const defaultLocales = {
  en: 'en_GB',
  sv: 'sv_SE',
  de: 'de_DE',
  fr: 'fr_FR',
  fi: 'fi_FI',
  nl: 'nl_NL',
}

export const changeLocale: (language: string) => AsyncAction<string> = (language: string) => {
  let locale = language + '_' + language.toUpperCase()
  if (defaultLocales[language]) {
    locale = defaultLocales[language]
  }

  return actionCreatorAsync<string>('CHANGE_LOCALE', async () => {
    return locale
  })
}

// convert POSIX locale format (with underscores, e.g. en_US)
// to BCP 47 locale format  (with hyphens, e.g. en-US)
export const convertPosixToBCP47Locale = (locale: string) => locale.replace('_', '-')
